/* ============================================================
   FLAVORPIX™ FLAVOR STATE — assets/fp-flavor-state.js
   ------------------------------------------------------------
   API globale partagée entre toutes les sections.
   À inclure UNE SEULE FOIS dans theme.liquid, AVANT toutes
   les autres sections FlavorPix.
   ------------------------------------------------------------
   Usage :
     window.flavorpix.setFlavor('peach');
     window.flavorpix.getFlavor();
     window.flavorpix.onChange((flavor) => { ... });
   ============================================================ */

(function (window) {
  'use strict';

  const FLAVORS = ['mint', 'peach', 'coffee', 'blueberry'];
  const DEFAULT_FLAVOR = 'mint';
  const STORAGE_KEY = 'fp_active_flavor';

  // ===================================================
  // État interne
  // ===================================================
  let currentFlavor = DEFAULT_FLAVOR;
  const listeners = new Set();

  // Récupère la dernière saveur visitée (persistence session)
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && FLAVORS.includes(stored)) {
      currentFlavor = stored;
    }
  } catch (e) { /* sessionStorage indispo, on continue */ }

  // ===================================================
  // Setter — change la saveur globale
  // ===================================================
  function setFlavor(flavor) {
    if (!FLAVORS.includes(flavor)) {
      console.warn('[flavorpix] Saveur inconnue:', flavor);
      return;
    }
    if (flavor === currentFlavor) return;

    const previousFlavor = currentFlavor;
    currentFlavor = flavor;

    // Mint = saveur par défaut, on enlève l'attribut pour rester sur les vars root
    if (flavor === DEFAULT_FLAVOR) {
      document.documentElement.removeAttribute('data-flavor');
      document.body.removeAttribute('data-flavor');
    } else {
      document.documentElement.setAttribute('data-flavor', flavor);
      document.body.setAttribute('data-flavor', flavor);
    }

    // Persistence
    try { sessionStorage.setItem(STORAGE_KEY, flavor); } catch (e) {}

    // Broadcast aux listeners
    listeners.forEach((fn) => {
      try { fn(flavor, previousFlavor); } catch (e) { console.error(e); }
    });

    // Custom event pour les listeners externes
    document.dispatchEvent(new CustomEvent('fp:flavorchange', {
      detail: { flavor, previousFlavor }
    }));
  }

  // ===================================================
  // Getter
  // ===================================================
  function getFlavor() {
    return currentFlavor;
  }

  // ===================================================
  // Subscribe
  // ===================================================
  function onChange(fn) {
    if (typeof fn !== 'function') return () => {};
    listeners.add(fn);
    return () => listeners.delete(fn); // returns unsubscribe
  }

  // ===================================================
  // Init au DOMContentLoaded — applique la saveur stockée
  // ===================================================
  function init() {
    if (currentFlavor !== DEFAULT_FLAVOR) {
      document.documentElement.setAttribute('data-flavor', currentFlavor);
      document.body.setAttribute('data-flavor', currentFlavor);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ===================================================
  // Expose API
  // ===================================================
  window.flavorpix = {
    setFlavor,
    getFlavor,
    onChange,
    FLAVORS: [...FLAVORS],
    DEFAULT_FLAVOR
  };
})(window);
